import { render, staticRenderFns } from "./online-quotation.vue?vue&type=template&id=6ec50a2e&scoped=true"
import script from "./online-quotation.vue?vue&type=script&lang=js"
export * from "./online-quotation.vue?vue&type=script&lang=js"
import style0 from "./online-quotation.vue?vue&type=style&index=0&id=6ec50a2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec50a2e",
  null
  
)

export default component.exports